import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import { UserFragmentDoc } from '../../../../../graphql/fragments/generated/User';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type UserQueryVariables = Types.Exact<{
  filters: Types.UserFilters;
}>;


export type UserQuery = { user?: { id: string, name?: string | null, uniqueId: string, emailId?: string | null, profilePicture?: string | null, orgRole?: { id: string, name: string } | null } | null };


export const UserDocument = /*#__PURE__*/ gql`
    query user($filters: UserFilters!) {
  user(filters: $filters) {
    ...User
  }
}
    ${UserFragmentDoc}`;

export function useUserQuery(options: Omit<Urql.UseQueryArgs<UserQueryVariables>, 'query'>) {
  return Urql.useQuery<UserQuery, UserQueryVariables>({ query: UserDocument, ...options });
};